import React from 'react';
import { ICompany, IContactInfo, ReservationOrder } from 'src/entities/company';
import AboutUs from '../AboutUs/AboutUs';
import BookingFlow from '../BookingFlow/BookingFlow';
import ContactInfo from '../ContactInfo/ContactInfo';
import Placeholder, { PagePlaceholder } from '../Placeholder/Placeholder';
import { useReducer, useEffect } from 'react';
import AvailabilityWarning from '../AvailabilityWarning';
import { EmbedModeType } from 'src/embed';
import { Routes } from 'src/routes';
import CallToAction from '../CallToAction';
import { useEmbedOptions } from 'src/contexts/EmbedContext';
import { useLocation } from 'react-router-dom';

interface IHomeProps {
    company: ICompany | null;
    contactInfo: IContactInfo | null;
}

const Home = ({ company, contactInfo }: IHomeProps) => {
    const location = useLocation();
    const hasDetails = company && (
        company.Description ||
        company.ShortDescription ||
        company.LogoLink ||
        company.BackgroundLink
    );

    const isHomeSlashRoute = location.pathname === Routes.HomeSlash;
    const isBookRoute = location.pathname === Routes.Book;
    const embedOptions = useEmbedOptions();
    const hideCompanyInfo = embedOptions && (embedOptions.hideCompanyInfo || embedOptions.mode !== EmbedModeType.WebPage);
    const [key, resetBookingFlow] = useReducer(state => ++state, 0);

    useEffect(() => {
        if (isHomeSlashRoute) {
            resetBookingFlow();
        }
    }, [isHomeSlashRoute])

    if (!company) {
        return <PagePlaceholder />
    }

    const hasBookingFlow = company.ReservationOrder !== ReservationOrder.OnlyPreReservation;

    return <>
        <div id="booking-flow" className="home__section App__booking-module">
            {hasBookingFlow
                ? <BookingFlow
                    key={key}
                    reservationOrder={embedOptions.order || company.ReservationOrder}
                    shouldHideInitialProgressBar={
                        !isBookRoute
                        && embedOptions.mode !== EmbedModeType.ProgressBar
                        && !!hasDetails
                    }
                />
                : <AvailabilityWarning type="bookingNotAvailable" />}
        </div>

        {isHomeSlashRoute && !hideCompanyInfo &&
            <>
                {company.Description &&
                    <>
                        <div id="about-us" className="home__section">
                            <AboutUs body={company.Description} />
                        </div>
                        {hasBookingFlow &&
                            <div className="home__section home__section--over">
                                <CallToAction />
                            </div>
                        }
                    </>
                }
                <div id="contact-info" className="home__section">
                    {contactInfo && <ContactInfo {...contactInfo} /> || <Placeholder />}
                </div>
            </>
        }
    </>
}

export default Home;


